import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import { useCart } from '../context/CartContext'; // ✅ импортируем
import {
    ShieldCheckIcon,
    ArrowTopRightOnSquareIcon,
    ClipboardDocumentListIcon,
    ShoppingCartIcon,
    ChartBarIcon,
    DocumentChartBarIcon,
    UserGroupIcon
} from '@heroicons/react/24/outline';

const Sidebar = () => {
    const { user } = useUser();
    const { getNewOrdersCount } = useCart(); // ✅ получаем функцию
    const newOrders = getNewOrdersCount?.() || 0;
    const location = useLocation();

    const isActive = (path) => location.pathname === path;

    return (
        <div className="fixed top-0 left-0 h-screen w-64 bg-gray-900 text-gray-200 p-4 flex flex-col shadow-lg z-10">
            {/* Logo or App Name */}
            <div className="mb-10 text-center">
                <h2 className="text-2xl font-semibold text-white">Приятного аппетита!</h2>
            </div>

            <nav className="flex-grow space-y-2">
                <Link
                    to="/dashboard"
                    className={`flex items-center gap-2 py-2 px-3 rounded-md text-sm transition ease-in-out duration-150 shadow ${
                        isActive('/dashboard') ? 'bg-teal-600 text-white font-semibold' : 'bg-teal-700 hover:bg-teal-600 text-white font-medium'
                    }`}
                >
                    <ChartBarIcon className="h-5 w-5" />
                    <span>Дашборд</span>
                </Link>

                <Link
                    to="/dishes"
                    className={`flex items-center gap-2 py-2 px-3 rounded-md text-sm transition ease-in-out duration-150 shadow ${
                        isActive('/dishes') ? 'bg-teal-600 text-white font-semibold' : 'bg-teal-700 hover:bg-teal-600 text-white font-medium'
                    }`}
                >
                    <ClipboardDocumentListIcon className="h-5 w-5" />
                    <span>Блюда</span>
                </Link>

                <Link
                    to="/orders"
                    className={`relative flex items-center gap-2 py-2 px-3 rounded-md text-sm transition ease-in-out duration-150 shadow ${
                        isActive('/orders') ? 'bg-teal-600 text-white font-semibold' : 'bg-teal-700 hover:bg-teal-600 text-white font-medium'
                    }`}
                >
                    <ShoppingCartIcon className="h-5 w-5" />
                    <span>Заказы</span>
                    {newOrders > 0 && (
                        <span className="absolute top-1 right-3 bg-red-600 text-white text-xs font-bold px-2 py-0.5 rounded-full shadow-md">
                            {newOrders}
                        </span>
                    )}
                </Link>

                <Link
                    to="/statistics"
                    className={`flex items-center gap-2 py-2 px-3 rounded-md text-sm transition ease-in-out duration-150 shadow ${
                        isActive('/statistics') ? 'bg-teal-600 text-white font-semibold' : 'bg-teal-700 hover:bg-teal-600 text-white font-medium'
                    }`}
                >
                    <DocumentChartBarIcon className="h-5 w-5" />
                    <span>Статистика</span>
                </Link>

                <Link
  to="/admin/supplier"
  className={`flex items-center gap-2 py-2 px-3 rounded-md text-sm transition ease-in-out duration-150 shadow ${
    isActive('/admin/supplier')
      ? 'bg-teal-600 text-white font-semibold'
      : 'bg-teal-700 hover:bg-teal-600 text-white font-medium'
  }`}
>
  <UserGroupIcon className="h-5 w-5" />
  <span>Поставщик</span>
</Link>


                <Link
    to="/billing"
    className={`flex items-center gap-2 py-2 px-3 rounded-md text-sm transition ease-in-out duration-150 shadow ${
        isActive('/billing') ? 'bg-teal-600 text-white font-semibold' : 'bg-teal-700 hover:bg-teal-600 text-white font-medium'
    }`}
>
    <DocumentChartBarIcon className="h-5 w-5" />
    <span>Счета</span>
</Link>

            </nav>

            {/* Admin Section */}
            {user?.role === 'admin' && (
                <div className="mt-auto border-t border-gray-700 pt-4">
                    <h3 className="px-4 text-xs uppercase text-gray-500 font-semibold mb-2">Админ</h3>
                    <Link
                        to="/admin"
                        className={`flex items-center gap-2 py-2 px-3 rounded-md text-sm transition ease-in-out duration-150 shadow ${
                            isActive('/admin') ? 'bg-blue-500 text-white font-semibold' : 'bg-blue-600 hover:bg-blue-500 text-white font-medium'
                        }`}
                    >
                        <ShieldCheckIcon className="h-5 w-5" />
                        <span>Панель</span>
                        <ArrowTopRightOnSquareIcon className="h-4 w-4 ml-auto" />
                    </Link>
                </div>
            )}
        </div>
    );
};

export default Sidebar;
